import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDList,
  FDPaper,
  FDSecondaryActionButton,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';
import { HouseholdMemberListItem } from './HouseholdMemberListItem';

export const HouseholdMemberList = ({
  collection,
  onClick,
  addMemberRelationship,
  onAddMember,
  selectedMember,
}) => {
  const isMobile = useMobileLayout();
  const maxWidth = (isMobile) ? '100%' : '30%';
  const minWidth = (isMobile) ? '100%' : 300;
  return (
    <FDPaper minWidth={minWidth} maxWidth={maxWidth} width={'100%'} padding={400} appearance={'elevated'}>
      <FDStack direction={'column'} spacing={2} height={'100%'}>
        <FDTitleText value={'Household Members'} size={'lg'} />
        <FDStack direction={'column'} flex={1}>
          <FDList>
            {collection.resources().list().map((resource) => {
              return (
                <HouseholdMemberListItem
                  key={resource.id()}
                  resource={resource}
                  onClick={onClick}
                  selectedMember={selectedMember}
                />
              );
            })}
          </FDList>
          {addMemberRelationship ? (
            <FDSecondaryActionButton
              {...dataAttrs('add-family-member-btn')}
              isFullWidth
              icon={'add'}
              onClick={() => onAddMember(addMemberRelationship)}
              label={addMemberRelationship.meta('prompt')}
            />
          ) : null}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

HouseholdMemberList.defaultProps = {
  onClick: null,
  addMemberRelationship: null,
  selectedMember: null,
};

HouseholdMemberList.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  onClick: PropTypes.func,
  addMemberRelationship: PropTypes.object,
  onAddMember: PropTypes.func.isRequired,
  selectedMember: PropTypes.instanceOf(fr.Resource),
};
